var render = function render(_c,_vm){return _c('div',_vm._b({staticClass:"spinner",class:_vm.data.staticClass || ''},'div',_vm.data.attrs,false),[_c('img',{attrs:{"src":"/assets/images/spinner.png","alt":"","srcset":"/assets/images/spinner.png" + " 1x, " + "/assets/images/spinner@2x.png" + " 2x, " + "/assets/images/spinner@3x.png" + " 3x"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }